import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Manager {
  name: string;
  api_token: string;
}

export interface ManagerInfo {
  errors: unknown;
  listManager: Manager;
  isAuthenticated: boolean;
}

@Module
export default class ManagerModule extends VuexModule implements ManagerInfo {
  errors = {};
  listManager = {} as Manager;
  managerDetail = {};
  listSearch = {};
  isAuthenticated = !!JwtService.getToken();

  get getListManager() {
    return this.listManager;
  }

  get getManagerDetail() {
    return this.managerDetail;
  }

  @Mutation
  [Mutations.MANAGER_LIST_DATA](listManager) {
    this.listManager = listManager;
  }

  @Mutation
  [Mutations.MANAGER_DETAIL_DATA](managerDetail) {
    this.managerDetail = managerDetail;
  }

  @Action
  [Actions.MANAGER_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/manager", payload)
        .then((data) => {
          this.context.commit(Mutations.MANAGER_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }

  @Action
  [Actions.MANAGER_DETAIL](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post(`/manager/${payload.id}/detail`)
        .then((data) => {
          this.context.commit(Mutations.MANAGER_DETAIL_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }

  @Action
  [Actions.MANAGER_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post(`manager/${payload.id}/delete`, payload)
        .then((res) => {
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }

  @Action
  [Actions.MANAGER_UPSERT](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      const idPath = payload.get("id") ? `/${payload.get("id")}` : "";
      return ApiService.post(`manager/upsert${idPath}`, payload)
        .then(() => {
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }

  @Action
  [Actions.CHANGE_PASSWORD](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post(`/change_password`, payload)
        .then(() => {
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }
}
